import queryString from 'query-string';

const loginPath = 'oauth/login';

/**
 * Servicios API
 *
 * @class ServiceApi
 */
class ServiceApi {

  constructor() {
    this.apiUrl = process.env.TBX_API_URL || (window.AppENV && window.AppENV.API_URL);
  }

  /**
   * Llama al endpoint para validar un login con usuario y contraseña.
   *
   * @param {*} username
   * @param {*} password
   * @param {*} parameters
   */
  userPassLogin(body, parameters, state) {
    const options = JSON.parse(JSON.stringify(body));

    options.grant_type = 'password';
    options['cf-turnstile-response'] = window.turnstile.getResponse();

    parameters.state = parameters.state || state;

    let headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8'
    };

    return fetch(this.apiUrl + loginPath + '?' + queryString.stringify(parameters), {
      method: 'post',
      headers: headers,
      body: JSON.stringify(options)
    })
      .then((response) => {
        if (response.status >= 400) {
          return response.json()
            .catch(error => {
              throw new Error(response.statusText, response.status);
            })
            .then((error) => {
              if (typeof error.error === 'string') {
                throw new Error(error.error_description, error.error);
              } else if (error.error && error.error.errorCode) {
                throw error.error;
              } else {
                throw new Error(error.message, error.code);
              }
            });
        }

        return response.json();
      })
      .catch((error) => {
        window.turnstile.reset()
        throw error;
      });
  }
}

export default ServiceApi;
